import type {Query} from '../query'
import {SearchLinkItem} from '../items/search-link-item'
import type {ServerDefinedItem} from '../items/server-defined-item'
import {ServerDefinedProvider} from './server-defined-provider'

/**
 * Provides links to search a repository, an organization/user, or all of GitHub.
 */
export class SearchLinksProvider extends ServerDefinedProvider {
  override enabledFor(query: Query): boolean {
    if (query.isBlank() || query.mode === '?' || query.mode === '>') {
      return false
    } else {
      return true
    }
  }

  override clearCache(): void {
    // nothing
  }

  override get hasCommands(): boolean {
    return false
  }

  override async fetch(query: Query, _isEmpty = false) {
    return {results: [SearchLinkItem.create(query)]} as {results: ServerDefinedItem[]}
  }
}
